/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marker_Import_Reading_File_ToastInputs */

const en_marker_import_reading_file_toast = /** @type {(inputs: Marker_Import_Reading_File_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reading file contents...`)
};

const fr_marker_import_reading_file_toast = /** @type {(inputs: Marker_Import_Reading_File_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lecture du contenu du fichier...`)
};

const de_marker_import_reading_file_toast = /** @type {(inputs: Marker_Import_Reading_File_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dateiinhalt wird gelesen...`)
};

const it_marker_import_reading_file_toast = /** @type {(inputs: Marker_Import_Reading_File_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lettura del contenuto del file...`)
};

const ru_marker_import_reading_file_toast = /** @type {(inputs: Marker_Import_Reading_File_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Чтение содержимого файла...`)
};

const es_marker_import_reading_file_toast = /** @type {(inputs: Marker_Import_Reading_File_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leyendo el contenido del archivo...`)
};

const zh_cn2_marker_import_reading_file_toast = /** @type {(inputs: Marker_Import_Reading_File_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在读取文件内容...`)
};

const ja_marker_import_reading_file_toast = /** @type {(inputs: Marker_Import_Reading_File_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ファイルの内容を読み込んでいます...`)
};

const hi_marker_import_reading_file_toast = /** @type {(inputs: Marker_Import_Reading_File_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ाइल की सामग्री पढ़ी जा रही है...`)
};

const pt_pt2_marker_import_reading_file_toast = /** @type {(inputs: Marker_Import_Reading_File_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lendo o conteúdo do arquivo...`)
};

/**
* | output |
* | --- |
* | "Reading file contents..." |
*
* @param {Marker_Import_Reading_File_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const marker_import_reading_file_toast = /** @type {((inputs?: Marker_Import_Reading_File_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marker_Import_Reading_File_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_marker_import_reading_file_toast(inputs)
	if (locale === "de") return de_marker_import_reading_file_toast(inputs)
	if (locale === "it") return it_marker_import_reading_file_toast(inputs)
	if (locale === "ru") return ru_marker_import_reading_file_toast(inputs)
	if (locale === "es") return es_marker_import_reading_file_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_marker_import_reading_file_toast(inputs)
	if (locale === "ja") return ja_marker_import_reading_file_toast(inputs)
	if (locale === "hi") return hi_marker_import_reading_file_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_marker_import_reading_file_toast(inputs)
	return en_marker_import_reading_file_toast(inputs)
});